import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const getListsMeta = () => {
	return axios.get('/api/list')
}

/**
 * @returns {Promise<Object>}
 */
export const getList = (type = '', query) => {
	return axios.get(`/api/list/${type}`, {params: query})
}